import {Component, Input, OnInit} from '@angular/core';
import {Activity, ActivityType} from '@shared/models/activity';
import {MatchDetailViewService} from '@modules/game-detail/services/match-detail-view.service';
import {LineupPlayer} from '@shared/models/lineup/lineup';
import {StateService} from '@core/services/state.service';
import { LibUtilsService } from '@utils/services/lib-utils.service';

@Component({
  selector: 'app-match-lineup-player',
  templateUrl: './match-lineup-player.component.html',
  styleUrls: ['./match-lineup-player.component.scss']
})
export class MatchLineupPlayerComponent implements OnInit {
  @Input() player: LineupPlayer;
  @Input() isHome = false;
  @Input() isAway = false;
  @Input() isSubstitute = false;
  @Input() hasFormation = false;
  @Input() noBorder = false;

  hasGoalActivity = false;
  hasCardActivity: 'yellow'|'red'|'yellow-red' = null;
  hasSubstitutionInActivity = false;
  hasSubstitutionOutActivity = false;
  goalCounter: number = 0;
  playerImgUrl = '';

  bgColor: string;
  fontColor: string;
  playerImgAvailable = true;

  isMobile = false;

  constructor(
    public matchDetailViewService: MatchDetailViewService,
  ) { }

  ngOnInit(): void {
    this.getActivitiesOfPlayer(this.player.playerid);
    this.setBackgroundColor();
    this.checkForPlaceholderPicture();
    this.isMobile = StateService.isMobile();
  }

  setBackgroundColor() {
    let bgColorAway = this.matchDetailViewService.data.awayTeam.frontend_settings.colors.background;

    if (this.player.position === 'Tor') {
      this.bgColor = '#026738FF';
    } else if (this.isHome) {
      this.bgColor = this.matchDetailViewService.data.homeTeam.frontend_settings.colors.background;
    } else if (this.isAway && bgColorAway === '#19132FFF') {
      this.bgColor = '#A51717';
    } else {
      this.bgColor = this.matchDetailViewService.data.awayTeam.frontend_settings.colors.background;
    }

    this.setFontColor();
  }

  setFontColor() {
    this.fontColor = LibUtilsService.isHexColorDark(this.bgColor) ? '#ffffff' : '#000000';
  }

  checkForPlaceholderPicture() {
    const faceImg = this.player.getFaceImage('small');
    if (!faceImg || faceImg.includes('placeholder')) {
      this.playerImgAvailable = false;
    } else {
      this.playerImgUrl = faceImg;
    }
  }

  getActivitiesOfPlayer(playerId: string) {
    if (!this.matchDetailViewService.data.homeLineup || !this.matchDetailViewService.data.awayLineup) {
      return [];
    }

    this.matchDetailViewService.data.entries.forEach(value => {
      if (value instanceof Activity) {
        if (value.playerid === playerId) {
          if (value.typeAsObj === ActivityType.GOAL ||
              value.typeAsObj === ActivityType.PENALTY_GOAL ||
              value.typeAsObj === ActivityType.FREE_KICK
          ) {
            this.goalCounter++;
            this.hasGoalActivity = true;
          }
          if (this.hasCardActivity === null && value.typeAsObj === ActivityType.YELLOW_CARD) {
            this.hasCardActivity = 'yellow';
          }
          if (this.hasCardActivity === null && value.typeAsObj === ActivityType.RED_CARD) {
            this.hasCardActivity = 'red';
          }
          if (this.hasCardActivity === null && value.typeAsObj === ActivityType.YELLOW_RED_CARD) {
            this.hasCardActivity = 'yellow-red';
          }
        }
        if (value.typeAsObj === ActivityType.SUBSTITUTION) {
          if (value.data) {
            if (value.data.in_playerid === playerId) {
              this.hasSubstitutionInActivity = true;
            }
            if (value.data.out_playerid === playerId) {
              this.hasSubstitutionOutActivity = true;
            }
          }
        }
      }
    });
  }
}
